import { render, staticRenderFns } from "./CreateWebCustomerModal.vue?vue&type=template&id=577e5142"
import script from "./CreateWebCustomerModal.vue?vue&type=script&lang=js"
export * from "./CreateWebCustomerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports